export const buildPaymentGenerateHref = (year, month) =>
	`/admin/payment?year=${year}&month=${month}&open=generar`;

const parsePeriodNumber = (value, min, max) => {
	if (value === null || value === undefined || value === '') {
		return undefined;
	}
	if (!/^-?\d+$/.test(String(value).trim())) {
		return undefined;
	}
	const parsed = Number(value);
	if (!Number.isInteger(parsed) || parsed < min || parsed > max) {
		return undefined;
	}
	return parsed;
};

export const readPaymentGenerateQuery = searchParams => {
	const year = parsePeriodNumber(searchParams.get('year'), 2020, 2030);
	const month = parsePeriodNumber(searchParams.get('month'), 1, 12);
	const openGenerar = searchParams.get('open') === 'generar';

	if (year === undefined || month === undefined) {
		return {
			valid: false,
			openGenerar: false,
		};
	}

	return {
		valid: true,
		year,
		month,
		openGenerar,
	};
};
